import Backbone from 'backbone';
import $ from 'jquery';

import CreateOligoModal from 'molbio/oligos/CreateOligoModal';
import {openImportOligoModal} from 'nav/CreateDropdownActions';
import ifCreateFromHash from 'util/ifCreateFromHash';
import runModal from 'ui-library/runModal';

class CreateImportOligoView extends Backbone.View {
  handleCreate() {
    function callback() {
      runModal(CreateOligoModal, {});
    }

    $(document).on('click', '.js-create-new-oligo', (e) => {
      e.preventDefault();
      callback();
    });
    const {hash} = window.location;
    if (hash.indexOf('#create/oligo') === 0) {
      callback();
      window.location.hash = '';
    }
  }

  handleImport() {
    function callback() {
      openImportOligoModal(null);
    }
    ifCreateFromHash('#import-oligo', callback);
  }

  render() {
    this.handleCreate();
    this.handleImport();
    return this;
  }
}

export default CreateImportOligoView;
